import o from "ramda/es/curryN";
import r from "ramda/es/path";
import t from "./__.js";
const m = o(2, (o, t) => void 0 !== r(o, t));
function n(o, r) {
  return r || (r = window && window.customElements), !r || !!r.get(o);
}
const i = m(t, window);
export { n as elementExists, m as existsIn, i as existsInWindow };
